import { render, staticRenderFns } from "./reviewList.vue?vue&type=template&id=0358c86c&scoped=true&"
import script from "./reviewList.vue?vue&type=script&lang=js&"
export * from "./reviewList.vue?vue&type=script&lang=js&"
import style0 from "./reviewList.vue?vue&type=style&index=0&id=0358c86c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0358c86c",
  null
  
)

component.options.__file = "reviewList.vue"
export default component.exports